import React from 'react'
import { Play } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const HeroSection = () => {
  const navigate = useNavigate()

  const handleStartTrial = () => {
    navigate('/signup')
  }

  const handleSeeFlow = () => {
    const element = document.getElementById('dashboard-preview')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section className="bg-gradient-to-b from-blue-50 to-white section-padding">
      <div className="container-padding">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Enterprise-level foot traffic insights — built for small businesses.
            </h1>
            <p className="text-lg text-gray-600 mb-2">
              Built for any small or medium business with walk-in customer traffic.
            </p>
            <p className="text-2xl text-blue-600 font-semibold mb-6">
              Find the rhythm of your business.
            </p>
            <p className="text-xl text-gray-600 mb-8">
              Real-time insights into foot traffic, customer flow, and visit trends — all from a simple plug-in sensor.
            </p>

            {/* CTA Buttons - aligned row */}
            <div className="flex flex-col sm:flex-row gap-4 mb-2">
              <button
                onClick={handleStartTrial}
                className="btn-primary"
              >
                30-Day Risk-Free Trial
              </button>
              <button
                onClick={handleSeeFlow}
                className="btn-secondary"
              >
                <Play className="w-5 h-5 mr-2" />
                See My Store's Flow
              </button>
            </div>
            <span className="text-sm text-gray-500">
              Hardware ships after signup. Trial converts to $99/month unless canceled.
            </span>
          </div>

          {/* Live Business Flow Screenshot */}
          <div className="marketingShot marketingShot--live">
            <div className="marketingShotInner">
              <img
                src="/images/marketing/live.png"
                alt="Live Business Flow Dashboard"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroSection
